<template>
  <div class="apply-sql">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请执行SQL</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Alert show-icon>
          <Icon type="ios-bulb-outline" slot="icon"></Icon>
          <template slot="desc">
            <pre style="white-space: normal;">目前支持 SQL 校验的功能，在提交 SQL 前请先校验 SQL，确认无误后提交。
SQL 注意事项：
1) 注释只支持 /* */ 格式，不支持 #、//、 --
2) 存储过程语句不需要使用 DELIMITER 关键字声明
3) 多条 SQL ，请使用 ; 号符隔开
4) SQL 需带库名</pre>
          </template>
        </Alert>
        <Form inline :label-width="75" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <FormItem label="实例" style="width: 100%" prop="instance">
            <Select v-model="baseInfo.instance" placeholder="请选择数据库实例" filterable transfer @on-change="changeInstance" clearable ref="execInstance" label-in-value>
              <OptionGroup label="MySQL">
                <Option v-for="item in instanceList.mysql" :value="'mysql_' + item.id" :key="'mysql_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
              <!--<OptionGroup label="MongoDB">-->
                <!--<Option v-for="item in instanceList.mongodb" :value="'mongodb_' + item.id" :key="'mongodb_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
              <OptionGroup label="SQL Server">
                <Option v-for="item in instanceList.sqlserver" :value="'sqlserver_' + item.id" :key="'sqlserver_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
            </Select>
          </FormItem>
          <FormItem label="执行 SQL" style="width: 100%" prop="execute_sql">
            <codemirror ref="myCm" v-model="baseInfo.execute_sql" :options="cmOptions" class="dbFlowApplyExecuteSql"></codemirror>
          </FormItem>
          <FormItem label="申请说明" style="width: 100%">
            <Input type="textarea" :maxlength="2048" v-model="baseInfo.application_content" :rows="6" placeholder="申请说明" />
          </FormItem>
        </Form>
        <div style="text-align: center;">
          <Button type="success" style="margin-right: 10px" :loading="submitting" @click="reView">SQL校验</Button>
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit" :disabled="(!reviewPass || baseInfo.execute_sql !== lastSql)">提交申请</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
        <Row style="margin-top: 20px" v-if="reviewResultData.length">
          <Row class="title">
            <h4 :style="{float: 'left'}">校验结果</h4>
          </Row>
          <Table
            border
            highlight-row
            ref="reViewTable"
            :data="reviewResultData"
            :columns="reviewColumns"></Table>
        </Row>
      </div>
    </Card>
  </div>
</template>

<script>
import { dbReleaseFlowApplySql } from '@/api/workflow/db_release_flow'
import { getAllInstance, InstanceReViewSql } from '@/api/database'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/edit/closebrackets.js' // 自动闭合符号
import 'codemirror/addon/edit/matchbrackets.js' // 匹配结束符号，比如"]、}"0
import GeneralAlert from '../components/general-alert'

export default {
  name: 'apply-sql',
  components: {
    codemirror,
    GeneralAlert
  },
  data () {
    return {
      cmOptions: {
        mode: {
          name: 'text/x-sql'
        },
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        foldGutter: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        showCursorWhenSelecting: true,
        // 在行槽中添加行号显示器、折叠器、语法检测器
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        // 快捷键
        extraKeys: {
          'Ctrl': 'autocomplete',
          'F11': function (cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'))
          },
          'Esc': function (cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
          }
        }
      },
      instanceList: {
        mysql: [],
        mongodb: [],
        sqlserver: []
      },
      baseInfo: {
        instance: '',
        instance_name: '',
        execute_sql: '',
        application_content: '',
        review_result: ''
      },
      lastSql: '',
      baseInfoFormRules: {
        instance: { required: true, message: '请选择实例', trigger: 'change' },
        execute_sql: { required: true, message: 'SQL不能为空', trigger: 'blur' }
      },
      submitting: false,
      reviewPass: false,
      sqlSameWithLast: false,
      reviewResultData: [],
      reviewColumns: [],
      reviewColumnsObject: {
        id: {
          width: 90,
          title: 'ID',
          tooltip: true,
          align: 'center',
          key: 'id'
        },
        stage: {
          width: 90,
          title: 'stage',
          tooltip: true,
          align: 'center',
          key: 'stage'
        },
        errlevel: {
          width: 90,
          title: 'errlevel',
          tooltip: true,
          align: 'center',
          key: 'errlevel'
        },
        stagestatus: {
          width: 90,
          title: 'stagestatus',
          tooltip: true,
          align: 'center',
          key: 'stagestatus'
        },
        errormessage: {
          minWidth: 200,
          title: 'errormessage',
          // tooltip: true,
          align: 'center',
          key: 'errormessage'
        },
        SQL: {
          minWidth: 120,
          title: 'SQL',
          tooltip: true,
          align: 'center',
          key: 'SQL'
        },
        index: {
          minWidth: 90,
          title: 'index',
          tooltip: true,
          align: 'center',
          key: 'index'
        },
        oneTitle: {
          minWidth: 90,
          title: 'title',
          tooltip: true,
          align: 'center',
          key: 'title'
        },
        result: {
          minWidth: 90,
          title: '语法校验结果',
          tooltip: true,
          align: 'center',
          key: 'result'
        }
      }
    }
  },
  mounted: function () {
    this.getInstances()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getInstances()
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.myCm.editor
      editor.on('keypress', function () { // 监听输入，自动弹出代码智能提示
        editor.showHint({
          completeSingle: false // 关闭在只有一个选项时自动完成拼写
        })
      })
      return editor
    }
  },
  methods: {
    // 提交
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.baseInfo.instance_id = this.baseInfo.instance.split('_')[1]
          this.baseInfo.instance_type = this.baseInfo.instance.split('_')[0]
          this.submitting = true
          dbReleaseFlowApplySql(this.baseInfo).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'dbReleaseFlowDetail', params: { id: res.data.id }})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 获取实例列表
    getInstances () {
      this.$refs.execInstance.clearSingleSelect()
      getAllInstance({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.instanceList = res.data
      })
    },
    // SQL校验
    reView () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          const reqData = {
            instance_id: this.baseInfo.instance.split('_')[1],
            instance_type: this.baseInfo.instance.split('_')[0],
            sql: this.baseInfo.execute_sql
          }
          this.lastSql = this.baseInfo.execute_sql
          this.submitting = true
          InstanceReViewSql(reqData).then(res => {
            this.baseInfo.review_result = res.data.result
            if (res.data.instance_type === 'mysql') {
              this.reviewPass = res.data.is_pass
              if (res.data.is_pass) {
                this.$Notice.success({title: '语法校验通过！'})
              } else {
                this.$Notice.error({title: '语法校验不通过！'})
              }
              if (res.data.result === 'ok') {
                this.reviewColumns = [this.reviewColumnsObject.result]
                this.reviewResultData = [
                  {
                    result: res.data.result
                  }
                ]
              } else if (res.data.result_type === 'explain') {
                this.reviewColumns = [this.reviewColumnsObject.SQL, this.reviewColumnsObject.errormessage]
                this.reviewResultData = []
                for (let i in res.data.result) {
                  this.reviewResultData.push({
                    SQL: i,
                    errormessage: res.data.result[i]
                  })
                }
              } else {
                this.reviewColumns = [this.reviewColumnsObject.id, this.reviewColumnsObject.stage,
                  this.reviewColumnsObject.errlevel, this.reviewColumnsObject.errormessage,
                  this.reviewColumnsObject.SQL]
                this.reviewResultData = []
                for (let i in res.data.result) {
                  this.reviewResultData.push({
                    id: res.data.result[i].ID,
                    stage: res.data.result[i].stage,
                    errlevel: res.data.result[i].errlevel,
                    errormessage: res.data.result[i].errormessage,
                    SQL: res.data.result[i].SQL
                  })
                }
              }
            } else if (res.data.instance_type === 'sqlserver') {
              if (res.data.result === 'ok') {
                this.reviewPass = true
                this.$Notice.success({title: '语法校验通过！'})
              } else {
                this.$Notice.error({title: '语法校验不通过！'})
              }
              this.reviewColumns = [this.reviewColumnsObject.result]
              this.reviewResultData = [
                {
                  result: res.data.result
                }
              ]
            }
            this.submitting = false
          }).catch(res => {
            this.submitting = false
          })
        }
      })
    },
    changeInstance (instanceObj) {
      this.reviewPass = false
      this.baseInfo.instance_name = instanceObj.label
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .dbFlowApplyExecuteSql {
    border: #dcdee2 1px solid;
    border-radius: 4px
  }
  .dbFlowApplyExecuteSql .CodeMirror{
    font-size: 15px;
  }
  .dbFlowApplyExecuteSql .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .dbFlowApplyExecuteSql .CodeMirror-hints {
    z-index: 1000 !important;
  }
</style>
